<script setup lang="ts">
import { siteDescription } from '~/constants/site'

useSeoMeta({
  title: 'Ongehoord - Het geluid van dieren',
  titleTemplate: '',
  description: siteDescription,
})
</script>

<template>
  <UPage>
    <HomeHeader />
    <div class="divide-y divide-neutral-200 dark:divide-neutral-800">
      <HomeSectionsJumbotron />
      <HomeSectionsInvestigations />
      <HomeSectionsMap />
      <HomeSectionsDonate />
    </div>
  </UPage>
</template>
